import {Backbone} from 'Vertebrae';
import {Webinar} from '../model/webinar';

export const Webinars = Backbone.Collection.extend({
    _name: 'Webinars',
    model: Webinar,
    url: '/webinars.json',
});
